import { Component, EventEmitter, OnDestroy, OnInit, Output, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GtwElementsBaseUrlsModel } from '../../../../app/shared/_models/gtw-elements-base-urls.model';
import { DomesticProjectTaggingService } from './domestic-project-tagging.service';
import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';
import {
  findAppkitItemByValue,
  getAppkitDropdownSelection,
  setDropdownAriaLabel
} from '../../../shared/utils/appkit-dropdown.util';

@Component({
    selector: 'gtw-domestic-project-tagging',
    templateUrl: './domestic-project-tagging.component.html',
    styleUrls: ['./domestic-project-tagging.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DomesticProjectTaggingComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);



	baseGlobalParams: any;
	baseURLs: GtwElementsBaseUrlsModel = { 'admin': '', 'api': '/gtw', "custom": '', 'efile': '', 'pdfEngine': '', 'bulkPdfEngine': '' };
	private baseURL = '/custom';
	private baseURLGtw = '/gtw';
	private checkLockedObj: any = [];
	private taggingParamObj: any = {};
	private taxYear: number = 0;
	private scenario: number = 0;
	private jcdKey: number = 0;
	private ssoId: number = 0;
	basket_id_value: any;
	ProjectTagAmt: any;
	rows: any = [];
	tableData = false;
	isModalLoading = false;
	autoRunDataLoad = false;
	tableLoadingData = false;
	FirstDiv = true;
	TwoDiv = false;
	basket_object: any = {};
	amt_exceed_obj: any = {};
	minimise = false;


	@Output('open-domestic-project-tagging-info')
	openDomesticTagInfo = new EventEmitter<string>();

	@Output('save-domestic-project-tagging-info')
	saveDomesticTagInfo = new EventEmitter<string>();

	@Output('close-modal')
	closeModalEvent = new EventEmitter<string>();

	@Output('request-grid-update')
	requestGridUpdate = new EventEmitter<string>();

	subscriptions: Subscription = new Subscription();




	constructor(
    private DomesticProjectTaggingService: DomesticProjectTaggingService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) { }

	SavedData: any = [];
	basketIdList: any = [];
	projectIdList: any = [];
	selectedBasketid: any = [];
	selectedProjectid: any = [];
	durationInSeconds = 5;
	CheckBasketFlag = false;
	tempGroupData: any = {};
	isResetBasketFlag = false;
	isResetProjectFlag = false;
	invalid_flag = true;
	isViewOnly: boolean = false;
	total_amt_exceed = false;
	private projectIdsLoaded = false;



	checkInputType(): boolean {
		const t = this.taggingParamObj;
		const filingGroup = t?.FILING_GROUP ?? t?.filing_group ?? t?.FILING_KEY ?? t?.filing_key;
		if (Number.isInteger(parseInt(this.taxYear + "")) &&
			Number.isInteger(parseInt(this.scenario + '')) &&
			Number.isInteger(parseInt(this.jcdKey + '')) &&
			Number.isInteger(parseInt(this.ssoId + '')) &&
			t && typeof t === 'object' &&
			filingGroup != null && filingGroup !== '' &&
			this.checkLockedObj
		) {
			return true;
		}

		return false;
	}


	ngOnInit(): void {
    this.applyWorkspaceContext();
    this.tryInit();
    this.subscriptions.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subscriptions.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
	}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const fp = normalizeFilterParams(activeScreen);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.baseGlobalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    this.checkLockedObj = this.baseGlobalParams?.checkLockedbj || this.checkLockedObj;
    this.taxYear = Number(fp?.tax_year ?? this.baseGlobalParams?.tax_year ?? this.taxYear ?? 0);
    this.scenario = Number(fp?.scenario ?? this.baseGlobalParams?.scenario ?? this.scenario ?? 0);
    this.jcdKey = Number(fp?.jcd_key ?? this.baseGlobalParams?.jcd_key ?? this.jcdKey ?? 0);
    const sso = this.gtwApp?.USER_SETTINGS?.user?.sso_id;
    const n = Number(sso);
    this.ssoId = Number.isFinite(n) && !Number.isNaN(n) ? n : this.ssoId;
    this.rebuildTaggingParamObj(activeScreen, fp);
  }

  /** Merge filter params + grid row into domestic project-tagging API payload. */
  private rebuildTaggingParamObj(activeScreen: any, fp: any): void {
    const raw = rowPayloadFromActiveScreen(activeScreen);
    const rowObj = Array.isArray(raw) ? (raw[0]?.data ?? raw[0]) : extractObject(raw);
    const g = extractObject(this.baseGlobalParams);
    const base = { ...extractObject(fp), ...extractObject(rowObj) };
    const pick = (...keys: string[]) => {
      for (const k of keys) {
        const v = base[k];
        if (v !== undefined && v !== null && v !== '') {
          return v;
        }
      }
      return undefined;
    };
    this.taggingParamObj = {
      ...base,
      FILING_GROUP: pick('FILING_GROUP', 'filing_group', 'FILING_KEY', 'filing_key') ?? g.filing_key ?? g.FILING_KEY,
      JOB_ID: pick('JOB_ID', 'job_id'),
      BSLA_CODE: pick('BSLA_CODE', 'bsla_code'),
      COUNTRY_CODE: pick('COUNTRY_CODE', 'country_code'),
      DCS_POST_FLIP: pick('DCS_POST_FLIP', 'dcs_post_flip'),
      FSE_PRE_FLIP: pick('FSE_PRE_FLIP', 'fse_pre_flip'),
      FSE_SOURCE_CODE: pick('FSE_SOURCE_CODE', 'fse_source_code'),
      FSI_SOURCE_CODE: pick('FSI_SOURCE_CODE', 'fsi_source_code'),
      INCOME_CATEGORY: pick('INCOME_CATEGORY', 'income_category'),
      INCOME_CATEGORY_TYPE: pick('INCOME_CATEGORY_TYPE', 'income_category_type'),
      PAYOR_CDR: pick('PAYOR_CDR', 'payor_cdr'),
      PAYOR_LEID: pick('PAYOR_LEID', 'payor_leid'),
      PTI_SUBTYPE: pick('PTI_SUBTYPE', 'pti_subtype'),
      RECIPIENT_CDR: pick('RECIPIENT_CDR', 'recipient_cdr'),
      RECIPIENT_LEID: pick('RECIPIENT_LEID', 'recipient_leid'),
      REPORTING_PERIOD: pick('REPORTING_PERIOD', 'reporting_period'),
      SOURCE: pick('SOURCE', 'source'),
      SCH_M_TEMPLATE_ID: pick('SCH_M_TEMPLATE_ID', 'sch_m_template_id'),
      OWNERSHIP_PCT: pick('OWNERSHIP_PCT', 'ownership_pct'),
    };
  }

	init() {
		this.getProjectIdData();
	}

  private tryInit(): void {
    if (this.projectIdsLoaded) {
      return;
    }
    this.init();
  }


	modalClose() {
		this.openDomesticTagInfo.emit('open-domestic-project-tagging-info');
		this.closeModalEvent.emit('cancel');
	}


	

	getProjectIdData() {
		if(!this.isModalLoading) {
			this.isModalLoading = true;
		this.basketIdList = [];

		this.projectIdList = [];
		this.DomesticProjectTaggingService.getProjectIdData(this.baseURLs.api, this.taxYear, this.scenario).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
			if (data) {
				let tempProjectId: any = [];
				data.forEach((value: any, i: any) => {
					let tempChannel = {
						value: value.PROJECT_ID,
						index: i,
						label: value.PROJECT_NAME,
						selected: false
					}
					tempProjectId.push(tempChannel);
				});
				this.projectIdList = tempProjectId;
				this.projectIdsLoaded = true;
				if (this.checkInputType()) {
					this.getModalSaveData();
				} else {
					this.isModalLoading = false;
				}
				console.log(this.projectIdList);
			} else {
				this.isModalLoading = false;
			}
		}, error => {
			this.isModalLoading = false;
			console.log(error);
		});

		}
	}

	



	getModalSaveData() {
		 if (!this.autoRunDataLoad) {
			this.autoRunDataLoad = true;
       if (this.taggingParamObj.JOB_ID == undefined){
        this.isViewOnly = true;
       }else{
        this.isViewOnly = false;
       }
			this.DomesticProjectTaggingService.getSourceTaggingModalData(this.baseURLs.api, this.taxYear, this.scenario, this.jcdKey, this.taggingParamObj).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
				if (data.length > 0) {
					this.autoRunDataLoad = false;
					this.tableLoadingData = true;
					this.tableData = true;
					console.log(data);
					this.SavedData = data;
				} else {
					this.tableLoadingData = true;
					this.tableData = false;
					this.SavedData = [];
				}
			},
				error => {
					this.isModalLoading = false;
					this.autoRunDataLoad = false;
					console.log(error);
				}, () => {
					this.isModalLoading = false;
					this.autoRunDataLoad = false;
					console.log('Completed loading');
				});
		}
	}



	addRow() {
		this.TwoDiv = true;
    let tempObj : any = {};
    tempObj = _.merge({
			index: this.rows.length + 1,
			SELECTEDPROJECTID: '',
			PROJECT_AMT: '',
			projectList: _.cloneDeep(this.projectIdList),
			selectedProjectItem: null,
		}, this.taggingParamObj)

		this.rows.push(tempObj);

	}

	setDropdownAriaLabel(item: any, contextLabel: string = 'Option'): string {
		return setDropdownAriaLabel(item, contextLabel);
	}

	onRowProjectSelect(event: any, row: any): void {
		const selected = getAppkitDropdownSelection(event);
		row.selectedProjectItem = selected;
		row.SELECTEDPROJECTID = selected?.value ?? '';
	}

	onRowProjectSelectItem(event: any, row: any): void {
		const selected = getAppkitDropdownSelection(event);
		if (selected) {
			row.selectedProjectItem = selected;
		}
	}

	private syncRowProjectSelection(row: any): void {
		row.selectedProjectItem = findAppkitItemByValue(row.projectList, row.SELECTEDPROJECTID);
	}
	onClick() {
		this.FirstDiv = !this.FirstDiv;
	}

	deleteRow(index: any) {
		this.rows.splice(index, 1);
		if (this.rows.length > 0) {
			this.TwoDiv = true;
		}
		else {
			this.TwoDiv = false;
		}
	}


  deleteRecord(seq_key: any) {
    console.log(seq_key);

		let updateSubscription = this.DomesticProjectTaggingService.deleteProjectTaggingData(this.baseURLs.api, seq_key, this.taxYear, this.scenario, this.jcdKey, this.ssoId, this.baseGlobalParams, this.taggingParamObj, this.checkLockedObj).subscribe(
			(data) => {
				if (data.callSuccess == "1") {     
					this.DomesticProjectTaggingService.openSnackBar('Data deleted Successfully', 'gtw-snackbar--green');
					this.saveDomesticTagInfo.emit('save-domestic-project-tagging-info');
					this.requestGridUpdate.emit('refresh');
				} else {
					this.DomesticProjectTaggingService.openSnackBar('Error Saving Data. ' + data.errorMessage, 'gtw-snackbar--red');
				}
			}, error => { this.DomesticProjectTaggingService.openSnackBar('Save failed. ' + error.error.errorMessage, 'gtw-snackbar--red'); },
			() => { console.log("Update Completed"); }
		);
		this.subscriptions.add(updateSubscription);

	}

	saveData() {
		console.log(this.rows);
    let saveObject = _.cloneDeep(this.rows)		
		if (saveObject.length > 0) {
			for (let i = 0; i < saveObject.length; i++) {
				delete saveObject[i].projectList;
				delete saveObject[i].index;

			}
		}
		if (this.SavedData.length > 0) {
			this.SavedData.forEach((dataValue: any, i: any) => {
				saveObject.push(dataValue)
			});
		}

		for (let i = 0; i < saveObject.length; i++) {
			this.invalid_flag = false;
			if ( (saveObject[i].SELECTEDPROJECTID === '' || saveObject[i].SELECTEDPROJECTID === null || saveObject[i].SELECTEDPROJECTID === undefined)
					|| (saveObject[i].PROJECT_AMT === '' || saveObject[i].PROJECT_AMT === null || saveObject[i].PROJECT_AMT === undefined)  
			){
				this.invalid_flag = true;
				break;
			}
			else {
				this.invalid_flag = false;
				
			}

		}
		if (this.invalid_flag) {
			this.DomesticProjectTaggingService.openSnackBar('Project Tag / Amount are required field', 'gtw-snackbar--red');
			return;
		}

		
		console.log(saveObject);
		let updateSubscription = this.DomesticProjectTaggingService.saveProjectTaggingData(this.baseURLs.api, saveObject, this.taxYear, this.scenario, this.jcdKey, this.ssoId, this.baseGlobalParams, this.taggingParamObj, this.checkLockedObj).subscribe(
			(data) => {
				if (data.callSuccess == "1") {
					this.DomesticProjectTaggingService.openSnackBar('Data Saved Successfully', 'gtw-snackbar--green');
					this.saveDomesticTagInfo.emit('save-domestic-project-tagging-info');
					this.requestGridUpdate.emit('refresh');
				} else {
					this.DomesticProjectTaggingService.openSnackBar('Error Saving Data. ' + data.errorMessage, 'gtw-snackbar--red');
				}
			}, error => { this.DomesticProjectTaggingService.openSnackBar('Save failed. ' + error.error.errorMessage, 'gtw-snackbar--red'); },
			() => { console.log("Update Completed"); }
		);
		this.subscriptions.add(updateSubscription);

	}

}
